<template>
	<div>
		<main class="error" role="main">
			<component :is="component"></component>
		</main>
	</div>
</template>
<script>
import Vue from "vue";
import {mapState} from "vuex";

Vue.component("Error403", require("../views/errors/Error403").default);
Vue.component("Error404", require("../views/errors/Error404").default);
Vue.component("Error500", require("../views/errors/Error500").default);

export default {
	computed: {
		...mapState("errorsStore", [
			"error",
		]),
		component() {
			return "Error" + (this.error ?? "404");
		},
	},
};
</script>
